import { render, staticRenderFns } from "./DriverLegend.vue?vue&type=template&id=7155e5e5"
import script from "./DriverLegend.vue?vue&type=script&lang=js"
export * from "./DriverLegend.vue?vue&type=script&lang=js"
import style0 from "./DriverLegend.vue?vue&type=style&index=0&id=7155e5e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports